import Vue from 'vue'
import Router from 'vue-router'
import VueMeta from 'vue-meta'

import login from '@/components/login'
import homePage from '@/components/homePage'
// import custManage from '@/components/customer/customerManage'
import custManage from '@/components/managePage/customerPage/customerManagePage'
import addManage from '@/components/managePage/customerPage/addresseeManagePage'
import ordersManage from '@/components/order/ordersManage'
import orderCheck from '@/components/order/orderCheck'
import logisticsManage from '@/components/logistics/logisticsManage'
import logisticsCheck from '@/components/logistics/logisticsCheck'
import signManage from '@/components/signature/signatureFormManage'
import signOrder from '@/components/signature/signatureFormOrders'
import signImg from '@/components/signature/signatureFormImgs'
import deliveryManage from '@/components/delivery/deliveryManage'
import deliveryClockStatistics from '@/components/delivery/deliveryClockStatistics'
import deliveryDetail from '@/components/delivery/deliveryDetail'
import distributionStatistics from '@/components/delivery/distributionStatistics'
import tempeoraryManage from '@/components/tempeorary/tempeoraryManage'
import clockStatistics from '@/components/tempeorary/clockInStatistics'
import containerInfo from '@/components/container/containerInfo'
import containerInfohistory from '@/components/container/containerInfohistory'
import containerOrder from '@/components/container/containerOrder'
import containerOrderhistory from '@/components/container/containerOrderhistory'
import noEnterContainer from '@/components/container/noEnterContainer'
import containerQuery from '@/components/container/containerQuery'
import ordersHistory from '@/components/order/ordersHistory'
import formalWorkersManage from '@/components/formalWorkers/formalWorkersManage'
import formalWorkersClockStatistics from '@/components/formalWorkers/formalWorkersClockStatistics'
import reservedCargoManagement from '@/components/cargoManagement/reservedCargoManagement'
import amazonOrderManage from '@/components/amazonOrderManage/amazonOrderManage'
import amazonOrderManagehistory from '@/components/amazonOrderManage/amazonOrderManagehistory'
import signInImgList from '@/components/amazonOrderManage/signInImgList'
import orderNoQuery from '@/components/orderNoQuery'
import DiaoDuInfo from '@/components/DiaoDu/DiaoDuInfo'
import DiaoDuOrder from '@/components/DiaoDu/DiaoDuOrder'
import orderRecycleBin from '@/components/orderRecycle/orderRecycleBin'
import xiaoBao from '@/components/xiaobao/List'
import XiaoBaoPeo from '@/components/XiaoBaoPeo/XiaoBaoPeo'
import ChildAccount from '@/components/ChildAccount/ChildAccount'
import BaoGUoManager from '@/components/BaoGUoManager/BaoGUoManager'
import AreaManager from '@/components/AreaManager/AreaManager'
import BL from '@/components/BL/List'


const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
Vue.use(VueMeta)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    { path: '/redirect', redirect: '/' },
    {
      path: '/homePage',
      component: homePage,
      children: [
        { path: '/custManage', component: custManage },
        { path: '/addManage', component: addManage },
        { path: '/ordersManage', component: ordersManage},
        { path: '/orderCheck', component: orderCheck },
        { path: '/logisticsManage', component: logisticsManage},
        { path: '/logisticsCheck', component: logisticsCheck },
        { path: '/signManage', component: signManage },
        { path: '/signOrder', component: signOrder },
        { path: '/signImg', component: signImg},
        { path: '/deliveryManage', component: deliveryManage },
        { path: '/deliveryClockStatistics', component: deliveryClockStatistics },
        { path: '/deliveryDetail', component: deliveryDetail },
        { path: '/distributionStatistics', component: distributionStatistics },
        { path: '/tempeoraryManage', component: tempeoraryManage },
        { path: '/clockStatistics', component: clockStatistics },
        { path: '/containerInfo', component: containerInfo },
        { path: '/containerInfohistory', component: containerInfohistory },
        { path: '/containerOrder', component: containerOrder },
        { path: '/containerOrderhistory', component: containerOrderhistory },
        { path: '/noEnterContainer', component: noEnterContainer },
        { path: '/containerQuery', component: containerQuery },
        { path: '/ordersHistory', component: ordersHistory },
        { path: '/formalWorkersManage', component: formalWorkersManage },
        { path: '/formalWorkersClockStatistics', component: formalWorkersClockStatistics },
        { path: '/reservedCargoManagement', component: reservedCargoManagement },
        { path: '/amazonOrderManage', component: amazonOrderManage },
        { path: '/amazonOrderManagehistory', component: amazonOrderManagehistory },
        { path: '/signInImgList/:date', component: signInImgList },
        { path: '/DiaoDuInfo', component: DiaoDuInfo },
        { path: '/DiaoDuOrder', component: DiaoDuOrder },
        { path: '/orderRecycleBin', component: orderRecycleBin},
        { path: '/xiaoBao', component: xiaoBao},
        { path: '/XiaoBaoPeo', component: XiaoBaoPeo},
        { path: '/ChildAccount', component: ChildAccount},
        { path: '/BaoGUoManager', component: BaoGUoManager},
        { path: '/AreaManager', component: AreaManager},
        { path: '/BL', component: BL}

      ]
    },
    { path: '/orderNoQuery', component: orderNoQuery }
  ]
})